import React from 'react';
import { Box, Typography, Paper, useTheme, alpha } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const PassiveSearchEmptyState = ({ error, info }) => {
    const theme = useTheme();
    const isError = !!error;

    return (
        <Paper 
            variant="outlined" 
            sx={{ 
                p: { xs: 3, md: 6 }, 
                textAlign: 'center', 
                mt: 4, 
                borderRadius: 4,
                borderColor: isError ? 'error.main' : 'divider',
                bgcolor: isError ? alpha(theme.palette.error.main, 0.05) : 'transparent'
            }}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mx: 'auto',
                mb: 3,
                width: 80,
                height: 80,
                backgroundColor: alpha(isError ? theme.palette.error.main : theme.palette.primary.main, 0.1),
                borderRadius: '50%',
            }}>
                {isError ? 
                    <ErrorOutlineIcon sx={{ fontSize: 40, color: 'error.main' }} /> :
                    <SearchOffIcon sx={{ fontSize: 40, color: 'primary.main' }} />
                }
            </Box>
            <Typography variant="h5" sx={{ mb: 1, fontWeight: 500 }}>
                {isError ? "Search Error" : "No Candidates Found"}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '520px', mx: 'auto', lineHeight: 1.7 }}>
                {error || info || "Your search didn't return any results. Please try different keywords or broaden your search."}
            </Typography>
        </Paper>
    );
};

export default PassiveSearchEmptyState;